import type { BillingOffer } from '~/gql/billing/billing'
import { BillingPaymentTerm } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { formatCents } from '~/pages/backoffice/admin/billing/money'

type Props = {
  offer: BillingOffer
  term: BillingPaymentTerm
  pending: boolean
  disabled: boolean
  onSubscribe: () => void
}

/** Une offre de la grille : capacité, prix HT de l'échéance choisie, bouton de souscription. */
function TierOfferCard({ offer, term, pending, disabled, onSubscribe }: Props) {
  const { t, i18n } = useTranslation()
  const yearly = term === BillingPaymentTerm.UPFRONT
  const amount = yearly ? offer.upfrontYearlyAmountCents : offer.monthlyPriceCents
  const name = t(`billing.tier.${offer.tier}`)

  return (
    <div className="flex flex-col gap-3 rounded-lg border p-4">
      <div>
        <p className="text-lg font-semibold">{name}</p>
        <p className="text-sm text-muted-foreground">{t('billing.offers.capacity', { count: offer.capacity })}</p>
      </div>
      <p>
        <span className="text-2xl font-semibold tabular-nums">{formatCents(amount, i18n.language)}</span>
        <span className="ml-1 text-sm text-muted-foreground">{t(yearly ? 'billing.offers.perYear' : 'billing.offers.perMonth')}</span>
      </p>
      <Button
        type="button"
        className="mt-auto"
        disabled={disabled}
        aria-busy={pending}
        onClick={onSubscribe}
      >
        {/* Le nom accessible dit le palier ; pendant l'attente, il dit l'attente. */}
        {pending
          ? t('billing.offers.redirecting')
          : (
              <>
                <span aria-hidden>{t('billing.offers.subscribe')}</span>
                <span className="sr-only">{t('billing.offers.subscribeTo', { tier: name })}</span>
              </>
            )}
      </Button>
    </div>
  )
}

export default TierOfferCard
